import React from 'react';
import { Button, IconButton, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import RefreshIcon from '@mui/icons-material/Refresh';

interface QuizHeaderControlsProps {
  onBack: () => void;
  mode: 'normal' | 'reverse' | 'fill';
  onCycleMode: () => void;
  onReset: () => void;
}

export const QuizHeaderControls: React.FC<QuizHeaderControlsProps> = ({
  onBack, mode, onCycleMode, onReset,
}) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={onBack} sx={{ fontWeight: 'bold' }}>
        Change Set
      </Button>
      <Stack direction="row" spacing={1}>
        <Button
          startIcon={<SwapHorizIcon />}
          variant="outlined"
          onClick={onCycleMode}
          sx={{ textTransform: 'none', fontWeight: 'bold' }}
        >
          {mode === 'normal' && 'Swedish → English'}
          {mode === 'reverse' && 'English → Swedish'}
          {mode === 'fill' && 'Fill in the Blank'}
        </Button>
        <IconButton onClick={onReset} title="Reset Set Progress" color="error">
          <RefreshIcon />
        </IconButton>
      </Stack>
    </Stack>
  );
};
